import {
  GET_AXISCARE_REPORTS,
  GET_AXISCARE_REPORTS_FAILED,
  GET_AXISCARE_REPORTS_SUCCESS,
  GET_AXISCARE_SETUP,
  GET_AXISCARE_SETUP_FAILED,
  GET_AXISCARE_SETUP_SUCCESS,
  INIT_AXISCARE,
  INIT_AXISCARE_FAILED,
  INIT_AXISCARE_SUCCESS,
  RESET_AXISCARE_STATE,
} from "./actionTypes"

export const getAxisCareSetup = params => ({
  type: GET_AXISCARE_SETUP,
  payload: params,
})

export const getAxisCareSetupSuccess = response => ({
  type: GET_AXISCARE_SETUP_SUCCESS,
  payload: response,
})

export const getAxisCareSetupFailed = error => ({
  type: GET_AXISCARE_SETUP_FAILED,
  payload: error,
})

export const getAxisCareReports = params => ({
  type: GET_AXISCARE_REPORTS,
  payload: params,
})

export const getAxisCareReportsSuccess = response => ({
  type: GET_AXISCARE_REPORTS_SUCCESS,
  payload: response,
})

export const getAxisCareReportsFailed = error => ({
  type: GET_AXISCARE_REPORTS_FAILED,
  payload: error,
})

export const initAxisCare = params => ({
  type: INIT_AXISCARE,
  payload: params,
})

export const initAxisCareSuccess = () => ({
  type: INIT_AXISCARE_SUCCESS,
  payload: {},
})

export const initAxisCareFailed = error => ({
  type: INIT_AXISCARE_FAILED,
  payload: error,
})

export const resetAxisCareState = () => ({
  type: RESET_AXISCARE_STATE,
  payload: {},
})
